import React from 'react'
import { AppHeader, Icon } from '@nike/eds'
import config from '../config.js'

export default function AppNavBar() {
  return (
    <AppHeader
      logoSlot={<Icon color='black' name='NikeApp' width={'56px'} height={'64px'} />}
      appName={config.title}
    />
  )
}
